const emptyModel = {
  id: null,
  name: '',
  proxy_player_downloads: true,
  player_proxy_download_speed: 1
}

const emptyFilters = {
  title: undefined
}

export default {
  emptyModel,
  emptyFilters
}
